/**
 * ============================================================
 * SynlabAdminFooter.js — Footer Component
 * ============================================================
 *
 * Displays:
 *   -> Copyright notice
 *   -> Lab address
 *
 * Used on every ADMIN page:
 *   -> AdminDashboard, AdminPeople, AdminProjects, AdminPubs, AdminUsers
 *   -> AdminPerson, AdminProject, AdminPub
 *
 * Pure presentational component — no props or state.
 **/

import React from "react";
import "./css/SynlabAdminFooter.css";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function SynlabAdminFooter() {
  return (
    <footer className="admin-footer">
      <div className="admin-footer-content">

        {/* ----- COPYRIGHT ----- */}
        <div className="admin-footer-copyright">
          <p>© {new Date().getFullYear()} Synaesthetic Media Lab</p>
        </div>

        {/* ----- LAB ADDRESS ----- */}
        <div className="admin-footer-address">
          <p>
            Toronto Metropolitan Univeristy<br />
            Bell Trinity Square, Suite N103, 483 Bay St.<br />
            Toronto, ON, Canada, M5G 2E1
          </p>
        </div>

      </div>
    </footer>
  );
}

export default SynlabAdminFooter;
